<input type="text" class="input-search" [formControl]="termSearch" (keyup.enter)="search()">

<button (click)="search()" class="button-search">
  <img src="assets/icons/search-ico.svg" alt="search icon">
</button>
